import { Injectable } from '@angular/core';
import { AddressBookStore } from './address-book.store';
import { AddressBook } from './models/address-book.model';
import { tap, switchMap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { AddressBookQuery } from './address-book.query';
import { of, Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddressBookService {
  constructor(
    private addressBookStore: AddressBookStore,
    private addressBookQuery: AddressBookQuery,
    private apiService: ApiService
  ) {}

  fetchAddressBook(): Observable<null> {
    let request$ = this.apiService.get<AddressBook>('addressBook').pipe(
      tap((entities) => this.addressBookStore.set(entities)),
      mapTo(null)
    );

    return this.addressBookQuery.getHasCache() ? of(null) : request$;
  }

  public remove(id: number) {
    return this.apiService.delete('addressBook', id).pipe(tap(() => this.addressBookStore.remove(id)));
  }

  public add(fullName: string, emailAddress: string) {
    let contact: AddressBook = { Id: 0, FullName: fullName, EmailAddress: emailAddress };

    if (
      this.addressBookQuery.getCount(
        (contact: AddressBook) => contact.EmailAddress.trim().toLowerCase() === emailAddress.trim().toLowerCase()
      ) > 0
    ) {
      return throwError(() => new Error('Error: A contact with this email already exists.'));
    } else {
      return this.apiService.post('addressBook/create', contact).pipe(
        tap(() => this.addressBookStore.setHasCache(false)),
        switchMap(() => this.fetchAddressBook())
      );
    }
  }

  public update(contactId: number, fullName: string, emailAddress: string): Observable<any> {
    let contact: AddressBook = { Id: contactId, FullName: fullName, EmailAddress: emailAddress };

    if (contact.FullName === '' || contact.EmailAddress === '') {
      return throwError('Fullname/Email cannot be empty!');
    } else {
      if (
        this.addressBookQuery.getCount(
          (contact: AddressBook) =>
            contact.EmailAddress.trim().toLowerCase() === emailAddress.trim().toLowerCase() && contact.Id !== contactId
        ) > 0
      ) {
        return throwError('Error: A contact with this email already exists.');
      } else {
        return this.apiService.put('addressBook', 'save', contact).pipe(
          tap(() =>
            this.addressBookStore.update(contact.Id, {
              FullName: contact.FullName,
              EmailAddress: contact.EmailAddress,
            })
          )
        );
      }
    }
  }
}
